import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { dataSearchState } from "../state";
import IncludeExcludeAccordion from "./IncludeExcludeAccordion";

/** "513210 · Software Publishers" */
export const naicsItemLabel = (code, label) => (label ? `${code} · ${label}` : code);

/** NAICS filter: 2022 six-digit codes by sector (served by data-core), include / exclude. */
const NaicsFilterPanel = observer(() => {
  useEffect(() => {
    dataSearchState.loadNaicsCatalog();
  }, []);

  const groups = (dataSearchState.naicsCatalog || []).map(sector => ({
    id: sector.code,
    label: `${sector.code} · ${sector.label}`,
    items: (sector.codes || []).map(c => ({ id: c.code, label: naicsItemLabel(c.code, c.label) }))
  }));

  return (
    <IncludeExcludeAccordion
      includeKey="naics"
      excludeKey="naicsExclude"
      groups={groups}
      searchPlaceholder="Search by code or industry"
      loading={dataSearchState.naicsCatalogStatus === "loading"}
      error={dataSearchState.naicsCatalogStatus === "error"}
      onRetry={() => dataSearchState.loadNaicsCatalog()}
      emptyLabel="NAICS codes"
    />
  );
});

export default NaicsFilterPanel;
